import * as styles from './styles';

import type { Vehicle } from '@cobliteam/common-types';

import { colors, DescriptionTitle, PlaceholderText } from '@cobliteam/base-components';
import OverflowHintText from '@cobliteam/base-components/src/OverflowHintText';

const VehicleCell = ({ vehicle }: { vehicle: Vehicle }) => {
  if (vehicle.licensePlate || vehicle.model.brand || vehicle.model.name) {
    return (
      <div className={styles.vehicleInfoContainer}>
        {vehicle.licensePlate && <DescriptionTitle color={colors.black}>{vehicle.licensePlate}</DescriptionTitle>}
        {(vehicle.model.brand || vehicle.model.name) && <OverflowHintText text={`${vehicle.model.brand || ''} ${vehicle.model.name || ''}`.trim()} maxWidth={170} />}
      </div>
    );
  }

  if (vehicle.cobliId) {
    return <DescriptionTitle color={colors.black}>{vehicle.cobliId}</DescriptionTitle>;
  }

  return <PlaceholderText>Veículo sem identificação</PlaceholderText>;
};

export default VehicleCell;
